import { money, formatDate } from "@/lib/api";
import { StatusBadge, EmptyState } from "@/components/shared";
import { FileText } from "lucide-react";

export const RenterApplicationsTab = ({ applications, appFee, openPay, openForm }) => {
  if (applications.length === 0) {
    return (
      <div className="bg-white border border-line rounded-xl"><EmptyState icon={FileText} title="No applications" subtitle="Browse homes and apply to get started." /></div>
    );
  }
  return (
    <div className="space-y-3">
      {applications.map((a) => (
        <div key={a.id} className="bg-white border border-line rounded-xl p-5 flex items-center justify-between flex-wrap gap-2">
          <div>
            <div className="flex items-center gap-2"><p className="font-medium text-ink">{a.property_title}</p><StatusBadge status={a.status} /></div>
            <p className="text-sm text-mute mt-0.5">Started {formatDate(a.created_at)}{a.move_in_date ? ` · Move-in ${a.move_in_date}` : ""}</p>
            {a.status === "awaiting_fee" && <p className="text-xs text-amber-700 mt-1">Pay the application fee to continue.</p>}
            {a.status === "awaiting_form" && <p className="text-xs text-amber-700 mt-1">Fee paid — complete your application to submit it.</p>}
          </div>
          <div className="flex gap-2">
            {(a.status === "awaiting_fee" || !a.fee_paid) && a.status !== "awaiting_form" && (
              <button data-testid={`pay-fee-${a.id}`} onClick={() => openPay({ purpose: "application_fee", amount: appFee, label: "Pay Application Fee", application_id: a.id })} className="bg-forest text-white px-4 py-2 rounded-lg text-sm hover:bg-forest-hover">Pay {money(appFee)} Fee</button>
            )}
            {a.status === "awaiting_form" && (
              <button data-testid={`complete-app-${a.id}`} onClick={() => openForm(a)} className="bg-forest text-white px-4 py-2 rounded-lg text-sm hover:bg-forest-hover flex items-center gap-1.5"><FileText className="h-4 w-4" /> Complete application</button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
